import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DocumentService {
  readonly pdfPreviewUrl = signal<string | null>(null);

  getPdfUrl(nomcorto: string): string | null {
    if (!nomcorto) return null;
    return `assets/pdf/${nomcorto}.pdf`;
  }

  openPdfPreview(url: string): void {
    this.pdfPreviewUrl.set(url);
  }

  closePdfPreview(): void {
    this.pdfPreviewUrl.set(null);
  }
}
